module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.elementOuterClass,
    style: (_vm.elementOuterStyle)
  }, [_c('div', {
    class: _vm.elementClass,
    style: (_vm.elementStyle),
    on: {
      "click": _vm.elementClicked
    }
  }, [(_vm.element.type == 'Text') ? [_c('v-text-field', {
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'List') ? [_c('v-select', {
    attrs: {
      "items": _vm.options,
      "label": _vm.element.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Checkbox') ? [_c('v-checkbox', {
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "color": "primary"
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Html') ? [_c('div', {
    staticClass: "grey--text text--darken-2",
    attrs: {
      "hide-details": _vm.hideDetails
    },
    domProps: {
      "innerHTML": _vm._s(_vm.htmlValue)
    }
  })] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af5f665a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/builder/ControlElement.vue
// module id = 2645
// module chunks = 1